import { createReducer, on } from '@ngrx/store';
import {
  AnchoredSectionValidated,
  ProjectFormStatusChanged,
  ProjectEditFormExitedAction,
  ProjectEditFormDataStabilized,
} from './project-edit-form.actions';
import { FormControlStatus } from '@angular/forms';

export interface ProjectEditFormState {
  anchorValidationErrorCounts: Record<string, number>;
  status: FormControlStatus;
  dataStable: boolean;
}

const initialState: ProjectEditFormState = {
  anchorValidationErrorCounts: {},
  status: null,
  dataStable: false,
};

export const projectEditFormReducer = createReducer(
  initialState,
  on(AnchoredSectionValidated, (state, { anchor, count }) => ({
    ...state,
    anchorValidationErrorCounts: {
      ...state.anchorValidationErrorCounts,
      [anchor]: count,
    },
  })),
  on(ProjectFormStatusChanged, (state, { status }) => ({ ...state, status })),
  on(ProjectEditFormDataStabilized, (state) => ({ ...state, dataStable: true })),
  on(ProjectEditFormExitedAction, () => ({ ...initialState })),
);
